<template>
  <div>
    <div class="js_dialog" :class="diaLogIos ? 'mask_act':'mask_nor'" id="iosDialog1">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__hd"><strong class="weui-dialog__title">{{ setDiaLog[0] }}</strong></div>
        <!--弹窗内容，告知当前状态、信息和解决方法，描述文字尽量控制在三行内-->
        <div class="weui-dialog__bd">{{ setDiaLog[1] }}</div>
        <div class="weui-dialog__ft">
          <div class="weui-dialog__btn weui-dialog__btn_default" @click="diaLogClick('0')" v-show="setDiaLog[3] !== ''">{{ setDiaLog[3] }}</div>
          <div class="weui-dialog__btn weui-dialog__btn_primary" @click="diaLogClick('1')">{{ setDiaLog[2] }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name:'diaLog',
    props:['diaLogIos','setDiaLog','orderStatus'],
    methods:{
//      diaLog 操作
      diaLogClick(status){
        this.$emit('diaLogClick',status);
      }
    }
  }
</script>

<style scoped>
  /*.mask_nor{*/
  /*  display: none;*/
  /*  opacity: 0;*/
  /*}*/
  /*.mask_act{*/
  /*  display: block;*/
  /*  animation: mask .3s linear forwards;*/
  /*}*/
  /*@keyframes mask {*/
  /*  0%{ opacity: 0}*/
  /*  100%{ opacity: 1}*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/diaLog.vue